export default {
  API: Symbol(),
  EVENT_BUS: Symbol(),
  LOCALIZATION: Symbol(),
  SETTINGS: Symbol(),
  PAGE: Symbol(),
  AUTH: Symbol(),
  LOGGER: Symbol(),
};
